import { render, staticRenderFns } from "./problemCom.vue?vue&type=template&id=a3246f6e&scoped=true"
import script from "./problemCom.vue?vue&type=script&lang=js"
export * from "./problemCom.vue?vue&type=script&lang=js"
import style0 from "./problemCom.vue?vue&type=style&index=0&id=a3246f6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3246f6e",
  null
  
)

export default component.exports